var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phone-controller"}},[_c('audio',{ref:"audio",attrs:{"autoplay":""}}),_c('dial-pad-modal',{attrs:{"engaging-call":_vm.engagingCall},on:{"call":_vm.startOutboundCall,"answer":_vm.answer,"terminate":_vm.terminate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }